import WithRoleAuthorization, { Role, listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'
import { notificationStatus } from 'constants/notificationStatus'
import { ForwardButton } from '../../styles'
import { CgMailForward } from 'react-icons/cg'
import { UserDataType } from 'types/autentication'


export interface IForwardToTreatment {
  currentUser: UserDataType
  archiveIconStyle: string
  isDirtyStyle: "" | "border-mediumGray text-mediumGray"
  isDirty: boolean
  handleOpenForwardNotification: () => void
  notificationStatusState: string
  actionsBack: string
  currentStepSelected: number
}
export const canForwardToTreatmentRoles = [listOfRoles.admin, listOfRoles.location_qa,listOfRoles.corporate_quality_board]
export default function ForwardToTreatment({
  currentStepSelected, currentUser, handleOpenForwardNotification, archiveIconStyle,
  isDirtyStyle, isDirty,
  notificationStatusState
}: IForwardToTreatment) {
  const shouldRenderButton = currentStepSelected === 1 &&
    notificationStatusState ===
    notificationStatus[0].label
  if (!shouldRenderButton) {
    return null
  }
  return (
    <WithRoleAuthorization
      allowedRoles={canForwardToTreatmentRoles}
      userRole={currentUser?.profile}
      children={
        <ForwardButton
          data-testid="test-forward-button"
          className={`${isDirtyStyle} ${isDirty && 'bg-disabled'
            }`}
          disabled={!!isDirty}
          type="button"
          onClick={handleOpenForwardNotification}
        >
          <CgMailForward
            className={archiveIconStyle}
          />
          Encaminhar para tratamento
        </ForwardButton>
      }
    />
  )
}
